import { render, staticRenderFns } from "./createmessageconfig.vue?vue&type=template&id=4143201a&"
import script from "./createmessageconfig.vue?vue&type=script&lang=ts&"
export * from "./createmessageconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createmessageconfig.vue"
export default component.exports